import React, { useContext, useState } from "react";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import CallToActionIcon from "@material-ui/icons/CallToAction";
import DoneIcon from "@material-ui/icons/Done";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import * as Dati from "src/Dati";
import * as Glob from "src/Globale";
import { Trad } from "src/components";
import { _ButtonAPI, _Dialog } from "..";
import useToggle from "../../../hooks/Toggle";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";

interface IChangeStatusButtonProps {
    RowData: Dati.CDatiDeroga;
    GetData: () => void;
}

export const _ChangeStatusButton: React.FC<IChangeStatusButtonProps> = ({ RowData, GetData }) => {
    const { open, toggle } = useToggle();
    const { ShowDialog } = useContext(AlertDialogContext);
    const [Note, setNote] = useState("");

    const OnChangeNote = (e: React.FormEvent<any>) => {
        setNote(e.currentTarget.value);
    };

    const GetFormData = (state: string): any => ({
        ...RowData,
        Note: Note,
        ID_TipoDerogaStato: state
    });

    const OnChangeStatus = (data: Dati.CRisAPI) => {
        toggle();

        if (data.Errore) {
            ShowDialog("ERRORE", Trad.Trad(data.ErrTesto), "error");
        } else {
            ShowDialog("DEROGA", Trad.Trad("Richiesta cambio stato avvenuto con successo"), "success");
            GetData();
        }
    };

    const OnError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    return RowData.Elaborata ? (
        <Icon fontSize="small" color="disabled">
            <DoneIcon />
        </Icon>
    ) : (
        <>
            <Tooltip title={Trad.Trad("Modifica")}>
                <span>
                    <IconButton aria-label="edit" size="small" disabled={!RowData.Abilitato} onClick={toggle}>
                        <CallToActionIcon />
                    </IconButton>
                </span>
            </Tooltip>
            <_Dialog
                Open={open}
                Title={Trad.Trad("Deroga")}
                Type="warning"
                Actions={
                    <>
                        <_ButtonAPI
                            URL="/api/Deroga/AggiornaStato"
                            Testo={Trad.Trad("LevelUP")}
                            OnInvio={() => GetFormData(Glob.Tipi_DR_Passa)}
                            OnClick={OnChangeStatus}
                            OnErrore={OnError}
                            Icona={<ArrowUpwardIcon />}
                        />
                        <_ButtonAPI
                            URL="/api/Deroga/AggiornaStato"
                            Testo={Trad.Trad("Approva")}
                            OnInvio={() => GetFormData(Glob.Tipi_DR_Approvata)}
                            OnClick={OnChangeStatus}
                            OnErrore={OnError}
                            Icona={<ThumbUpAltIcon />}
                        />
                        <_ButtonAPI
                            URL="/api/Deroga/AggiornaStato"
                            Testo={Trad.Trad("Rifiuta")}
                            OnInvio={() => GetFormData(Glob.Tipi_DR_Rifiutata)}
                            OnClick={OnChangeStatus}
                            OnErrore={OnError}
                            Icona={<HighlightOffIcon />}
                        />
                    </>
                }
                OnClose={toggle}
            >
                <form noValidate>
                    <TextField multiline fullWidth variant="outlined" id="Note" label={Trad.Trad("Note")} rows={3} rowsMax={5} value={Note} onChange={OnChangeNote} />
                </form>
            </_Dialog>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/SpecialAcceptanceList/ChangeStatusButton.tsx